import React, { Component } from "react";
import MessageList from "./MessageList";
import Firebase from "../firebasehelper";
import { FadeLoader } from "react-spinners";
import { css } from "@emotion/core";
const queryString = require("query-string");

const override = css`
  position: absolute;
  top: 48%;
  left: 48%;
  radius: 2px;
  height: 15px;
  width: 5px;
  display: block;
  margin: 0 auto;
  border-color: grey;
`;

class Screen extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      restart: false,
      loading: true,
      background: "#fff"
    };
  }
  async componentDidMount() {
    const { name, logo, color, icon } = this.props;
    const parsed = queryString.parse(this.props.location.search);
    console.log("parsed", parsed);
    if (parsed.uid) {
      Firebase.getProfileByUID(parsed.uid, name).then(res => {
        console.log("user profile", res);
        if (res)
          this.setState({
            profile: res,
            uid: parsed.uid,
            restart: true,
            loading: false
          });
        else alert("User is not existing.");
      });
    } else this.setState({ loading: false });

    document.title = name;
    let link =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    link.type = "image/png";
    link.rel = "icon";
    link.href = icon;
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  render() {
    const { uid, restart, loading, background } = this.state;
    const { name, icon } = this.props;
    return (
      <div className="app-wrapper">
        <div className="bg" style={{ backgroundColor: background }} />
        {loading && (
          <FadeLoader
            css={override}
            sizeUnit={"px"}
            size={100}
            loading={loading}
          />
        )}
        {!loading && (
          <MessageList
            {...this.props}
            logo={name}
            icon={icon}
            restart={restart}
            uid={uid}
          />
        )}
      </div>
    );
  }
}
export default Screen;



// WEBPACK FOOTER //
// ./src/Components/Screen.js